import { FollowRequestComponent } from './../follow-request/follow-request.component';
import { NbDialogService } from '@nebular/theme';
import { WfRequest } from './../../models/request';
import { Component, OnInit } from '@angular/core';
import { RequestService } from '../../services/request.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-my-requests',
  templateUrl: './my-requests.component.html',
  styleUrls: ['./my-requests.component.scss'],
})
export class MyRequestsComponent implements OnInit {
  result: WfRequest[] = [] as WfRequest[];
  constructor(private service: RequestService, private dialogService: NbDialogService) {}

  ngOnInit() {
    this.loadRequests();
  }

  loadRequests() {
    this.service.myRequests().subscribe((result: WfRequest[]) => {
      this.result = result;
    });
  }
  status(item: WfRequest, isComplete: boolean) {
    this.dialogService.open(FollowRequestComponent, { context: { item: item.wfProcessStateVms, complete: isComplete } });
  }
  Detail(id: number, criteriaType: number, title: string) {
   
 }
}
